import React from "react";
import { DepartmentListScreenContext } from "./context";

export const useDepartmentListScreen = () => {
  const context = React.useContext(DepartmentListScreenContext);

  if (!context)
    throw new Error(
      "useDepartmentListScreen must be used within a DepartmentListScreen Provider"
    );

  return context;
};
